import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class SubscriptionService {
    constructor(private http: HttpClient) { }

    getNewSubscriptions(): Observable<any> {
        const url = environment.apiBaseUrl + '/DiscordBot/GetNewSubscriptions';
        console.log(url);
        return this.http.get(url).pipe(
            map((res: any) => res),
            catchError((err) => throwError(err))
        );
    }
    getExpiredSubscriptions(): Observable<any> {
        const url = environment.apiBaseUrl + '/DiscordBot/GetExpiredSubscriptions';
        console.log(url);
        return this.http.get(url).pipe(
            map((res: any) => res),
            catchError((err) => throwError(err))
        );
    }
}
